/**
 * LossReasonModal — pede o motivo da perda antes de confirmar um negócio
 * como "Perdido". Extraído de Pipelines.jsx (usado ao soltar um card na
 * etapa de perda) para ser reaproveitado também na ação rápida de
 * Ganho/Perdido do DealPanel.
 *
 * Visual: mesmo padrão de modal centrado do módulo Financeiro (fc-modal-*).
 */

import { useEffect, useState } from 'react'
import Icon from '../../components/icons.jsx'
import { getLossReasons, createLossReason } from '../../db/api.js'
import '../financeiro/contas.css'

export default function LossReasonModal({ onConfirm, onCancel }) {
  const [reasons, setReasons] = useState([])
  const [reasonId, setReasonId] = useState('')
  const [novo, setNovo] = useState('')          // nome de um motivo novo
  const [justificativa, setJustificativa] = useState('')
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  useEffect(() => {
    let alive = true
    getLossReasons().then((r) => alive && setReasons(r)).catch(() => {})
    return () => { alive = false }
  }, [])

  const confirm = async () => {
    if (saving) return
    setSaving(true); setErr(null)
    try {
      let lossReasonId = reasonId || null
      const nome = novo.trim()
      if (!lossReasonId && nome) {
        const created = await createLossReason(nome)
        lossReasonId = created.id
      }
      await onConfirm({ lossReasonId, justificativa: justificativa.trim() || null })
    } catch (e) {
      setErr(e.message); setSaving(false)
    }
  }

  return (
    <div className="fc-modal-overlay fc-modal-overlay--top" onMouseDown={onCancel}>
      <div className="fc-modal" style={{ width: 460 }} onMouseDown={(e) => e.stopPropagation()}>
        <div className="fc-modal-head">
          <span className="fc-drawer-title">Marcar como perdido</span>
          <button className="fc-drawer-x" onClick={onCancel}><Icon n="x" s={16} sw={2} /></button>
        </div>
        <div className="fc-modal-body">
          <p style={{ margin: '0 0 12px', fontSize: 13, color: '#667085' }}>Por que este negócio foi perdido?</p>
          {err && <div className="fc-error">{err}</div>}

          <div className="fc-field">
            <label className="fc-label">Motivo</label>
            <select
              className="fc-select"
              value={reasonId}
              onChange={(e) => { setReasonId(e.target.value); setNovo('') }}
            >
              <option value="">— selecione —</option>
              {reasons.map((r) => <option key={r.id} value={r.id}>{r.nome}</option>)}
            </select>
          </div>

          {!reasonId && (
            <div className="fc-field">
              <label className="fc-label">ou crie um novo motivo</label>
              <input
                className="fc-input"
                value={novo}
                onChange={(e) => setNovo(e.target.value)}
                placeholder="Ex.: preço, sem retorno, comprou do concorrente…"
              />
            </div>
          )}

          <div className="fc-field">
            <label className="fc-label">Justificativa (opcional)</label>
            <textarea
              className="fc-input"
              style={{ height: 'auto', minHeight: 64, padding: '10px 12px', resize: 'vertical' }}
              value={justificativa}
              onChange={(e) => setJustificativa(e.target.value)}
            />
          </div>
        </div>

        <div className="fc-modal-foot">
          <button className="fc-ctrl" onClick={onCancel} disabled={saving}>Cancelar</button>
          <button className="pm-btn-danger solid" onClick={confirm} disabled={saving}>
            {saving ? 'Salvando…' : 'Confirmar perda'}
          </button>
        </div>
      </div>
    </div>
  )
}
